(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.hh-faq__summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details || details.tagName !== 'DETAILS') return;
      e.preventDefault();

      if (details.open) {
        details.classList.add('hh-faq__details--closing');
        var DUR = 320;
        window.setTimeout(function () {
          details.removeAttribute('open');
          details.classList.remove('hh-faq__details--closing');
        }, DUR);
      } else {
        details.setAttribute('open', '');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
